import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

interface ReminderModalProps extends ModalProps {
  onContinue: () => void;
}

export const ReminderModal = ({
  show,
  onClose,
  onContinue,
}: ReminderModalProps) => {
  const navigate = useNavigate();

  const handleCancelRequest = () => {
    onClose();
    navigate(ROUTES.CONSULTATIONS.OVERVIEW);
  };
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>{t`Just a friendly reminder`}</Dialog.Title>

          <Dialog.Description>
            {t`It appears you have 3 or more injections left. We will only process a refill if you have 2 or fewer doses left at the time of your session`}
          </Dialog.Description>
          <Dialog.Description>
            {t`Would you like to proceed with your consultation anyway, or cancel and return later?`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button onClick={onContinue} size="lg" variant="secondary">
            {t`Proceed anyway`}
          </Button>
          <Button onClick={handleCancelRequest} size="lg">
            {t`Cancel request`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
